export default "__VITE_ASSET__DX5dOAlx__"